import { of } from 'rxjs';
import './playground';

export const example$ = of(1, 2, 3, 4);
